import service from '@/services/service'
import Qs from 'qs'
import { APIPermission } from '@/models/api/permission.model'

const resource = {
    main: 'services',
    module: 'permissions'
}

export class PermissionsServices {
    public static getPermissions () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getPermissionsPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getPermissionsById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createPermissions (params: APIPermission) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editPermissions (params: APIPermission) {
        return service.put(`${resource.main}/${resource.module}/${params.permissionId}`, params)
    }

    public static deletePermissions (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }
}
